import { render } from "./SIPChannels.vue?vue&type=template&id=5d3143e8"
import script from "./SIPChannels.vue?vue&type=script&lang=js"
export * from "./SIPChannels.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__